import { Modal } from "antd";

export async function PostUseTestJavamon(idAct: string, idProb: string, userId: string, idJavamon: string) {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${idAct}/problemes/${idProb}/view-tests`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_usuari: userId, id_javamon: idJavamon })
        });

        if (response.status !== 200) {
            Modal.error({
                title: 'Error',
                content: 'No se ha podido utilizar el Javamon Test. Verifica que no hayas usado ya uno en esta actividad o que tengas permisos.',
            });
            return false;
        }

        return true;
    } catch (e) {
        console.error("PostUseTestJavamon Error:", e);
        throw e;
    }
}
